import { DateValue, parseDate } from "@ark-ui/react";

const mapStringToDateValue = ({
  value: valueString,
  defaultValue: defaultValueString,
  focusedValue: focusedValueString,
}: {
  value?: string[];
  defaultValue?: string[];
  focusedValue?: string;
}): {
  value?: DateValue[];
  defaultValue?: DateValue[];
  focusedValue?: DateValue;
} => {
  const formattedValue = valueString?.map((value) => new Date(value));
  const value = formattedValue?.map((value) => parseDate(value));
  const defaultValue = defaultValueString?.map((value) =>
    parseDate(new Date(value)),
  );
  const focusedValue = focusedValueString
    ? parseDate(new Date(focusedValueString))
    : undefined;

  return { value, defaultValue, focusedValue };
};

export default mapStringToDateValue;
